import React, { useEffect, useState } from "react";
import { sendalerts } from "./api";
import { Alert, Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import Table from 'react-bootstrap/Table'
import { alertstemplate, incidenthistory } from "./api"
const EXCEENDANCE_WARNING_PAGE = ' You can also view exceedance warnings here: ' + '{{warnings_url}}' + '/warnings'; //TBD this is also in the alerts lambda

export const SendAlertsModal = ({ showModal, onClose }) => {
    const INCIDENT_TYPE = {
        INCIDENT_STARTED: 0,
        INCIDENT_ENDED: 1,
        INCIDENT_ONGOING: -1  // ongoing custom messages
    };

    let [eng_emailtextpart, setEngEmailText] = useState("");
    let [eng_emailhtmlpart, setEngHTML] = useState("");
    let [eng_smspart, setEngSMSText] = useState("");
    let [eng_emailsubject, setEngEmailSubject] = useState("");

    let [sp_emailtextpart, setSpEmailText] = useState("");
    let [sp_emailhtmlpart, setSpHTML] = useState("");
    let [sp_smspart, setSpSMSText] = useState("");
    let [sp_emailsubject, setSpEmailSubject] = useState("");



    let [submitting, setSubmitting] = useState(false);
    let [submitted, setSubmitted] = useState(false);
    let [error, setError] = useState("")
    let [templatedata, setTemplateData] = useState(Object);
    let [templatedatatextpart, setTemplateDataTextPart] = useState("");
    let [templatedatasubjectpart, setTemplateDataSubjectPart] = useState("");
    let [incidentstatus, setIncidentStatus] = useState(INCIDENT_TYPE.INCIDENT_STARTED);
    let [loaded, setLoaded] = useState(false)
    let [incidenthistorydata, setIncidentHistoryData] = useState([]);


    const prettytimestamp = (time_at) => {
        const dateObject = new Date(time_at * 1000)
        return dateObject.toLocaleString().replace(',', '') //2019-12-9, 10:30:15
    }

    const endIncident = async (index) => {
        setSubmitting(true)
        let payload = {
            eng_emailtextpart: "",
            eng_emailtextpart: "",
            eng_emailhtmlpart: "",
            eng_smspart: "",
            incidentstatus: incidentstatus,
            incidentid: incidenthistorydata[index].id,
            started_at: incidenthistorydata[index].started_at
        }
        await sendalerts(payload);
        setSubmitting(false);
        setSubmitted(true);

    }
    const handleRadioChange = async (e) => {
        const { value } = e.target
        //console.log("radio", value)

        if (value === "started") {
            setIncidentStatus(INCIDENT_TYPE.INCIDENT_STARTED);
        } else if (value === "ongoing") {
            setIncidentStatus(INCIDENT_TYPE.INCIDENT_ONGOING);
        } else if (value === "ended") {
            setIncidentStatus(INCIDENT_TYPE.INCIDENT_ENDED);
        }
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        try {
            setSubmitting(true)
            setTemplateData(null)
            let payload = {
                eng_emailsubject: eng_emailsubject,
                eng_emailtextpart: eng_emailtextpart,
                eng_emailhtmlpart: eng_emailhtmlpart,
                eng_smspart: eng_smspart,
                sp_emailsubject: sp_emailsubject,
                sp_emailtextpart: sp_emailtextpart,
                sp_emailhtmlpart: sp_emailhtmlpart,
                sp_smspart: sp_smspart,
                incidentstatus: incidentstatus
            }

            await sendalerts(payload);

            setSubmitting(false);
            setSubmitted(true);
        } catch (e) {
            console.error("really oh noes", e)
        }
        return false;

    }

    useEffect(() => {
        let mounted = true;
        try {
            alertstemplate()
                .then(data => {
                    if (mounted) {
                        setTemplateData(data)
                        setTemplateDataTextPart(data.TextPart.replace('{{alertBodyPlainText}}', EXCEENDANCE_WARNING_PAGE).replace('{{alertBodyHtml}}', EXCEENDANCE_WARNING_PAGE))
                        setTemplateDataSubjectPart(data.SubjectPart)
                        setSubmitting(false);
                        setSubmitted(false);
                    }
                })
            incidenthistory()
                .then(items => {
                    if (mounted) {
                        // console.log(items)
                        items.sort((a, b) => a.id < b.id ? 1 : -1)
                        setIncidentHistoryData(items);
                    }
                })
            setLoaded(true)
        } catch (e) {
            console.error("oh noes", e)
        }
        return () => { mounted = false; }
    }, [])

    return (
        <Modal show={showModal} onHide={onClose} dialogClassName={"modal-dialog-centered"}>
            <Modal.Header closeButton>
                <Modal.Title>Manage Incidents</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <Form onSubmit={onSubmit}>

                    {!submitted && <Form.Group>

                        <div onChange={e => handleRadioChange(e)}>
                            <input type="radio" value="started" name="incident" defaultChecked /> Start new incident
                            <input style={{ marginLeft: '20px' }} type="radio" value="ended" name="incident" /> End incident
                            <input style={{ marginLeft: '20px' }} type="radio" value="ongoing" name="incident" />  Send message
                        </div>
                        {incidentstatus === 0 && <React.Fragment>
                            <br />
                            <Form.Label>
                                Preview Message Content
                            </Form.Label>
                            <br />
                            <Table responsive striped bordered hover style={{ display: 'block', height: '200px', overflow: 'auto' }}>
                                <tbody>
                                    <tr >
                                        <td>SMS Content</td>
                                        <td><div>{templatedatatextpart}</div></td>
                                    </tr>
                                    <tr >
                                        <td>Email Subject</td>
                                        <td>{templatedatasubjectpart}</td>
                                    </tr>
                                    <tr >
                                        <td>Email Content</td>
                                        <td><div>{templatedatatextpart}</div></td>
                                    </tr>
                                </tbody>

                            </Table>
                        </React.Fragment>}
                        {incidentstatus === 1 && <React.Fragment>
                            <br />
                            <Form.Label>
                                Incidents
                            </Form.Label>
                            <br />
                            <Table responsive striped bordered hover size="sm" style={{ display: 'block', height: '300px', overflow: 'auto' }}>
                                <thead>
                                    <tr>
                                        <th>Incident ID</th>
                                        <th>Incident Started Time</th>
                                        <th>Incident Ended Time</th>
                                    </tr>

                                </thead>
                                <tbody>
                                    {incidenthistorydata.map((val, key) => {
                                        return (
                                            <tr key={key}>
                                                <td>{val.id}</td>
                                                <td>{prettytimestamp(val.started_at)}</td>
                                                <td>{val.ended_at && prettytimestamp(val.ended_at)}
                                                    {!val.ended_at &&
                                                        <button type="button" className="btn btn-link"
                                                            onClick={() => endIncident(key)}
                                                        >End</button>}
                                                </td>


                                            </tr>
                                        )
                                    })}
                                </tbody>

                            </Table>
                        </React.Fragment>}
                        {incidentstatus === -1 && <React.Fragment>
                            <div className="mt-3">English Content</div>
                            <Form.Control className="mb-3" as="textarea" rows={1}
                                placeholder="Enter english email subject"
                                value={eng_emailsubject}
                                onChange={(e) => {
                                    setEngEmailSubject(e.target.value)
                                    setError("")
                                }}
                                disabled={submitting}
                            />
                            <Form.Control className="mb-3" as="textarea" rows={2}
                                placeholder="Enter english email text"
                                value={eng_emailtextpart}
                                onChange={(e) => {
                                    setEngEmailText(e.target.value)
                                    setError("")
                                }}
                                disabled={submitting}
                            />
                            <Form.Control className="mb-3" as="textarea" rows={2}
                                placeholder="Enter english email html"
                                value={eng_emailhtmlpart}
                                onChange={(e) => {
                                    setEngHTML(e.target.value)
                                    setError("")
                                }}
                                disabled={submitting}
                            />
                            <Form.Control className="mb-3" as="textarea" rows={2}
                                placeholder="Enter english sms text"
                                value={eng_smspart}
                                onChange={(e) => {
                                    setEngSMSText(e.target.value)
                                    setError("")
                                }}
                                disabled={submitting}
                            />
                            <div>Spanish Content</div>
                            <Form.Control className="mb-3" as="textarea" rows={1}
                                placeholder="Enter spanish email subject"
                                value={sp_emailsubject}
                                onChange={(e) => {
                                    setSpEmailSubject(e.target.value)
                                    setError("")
                                }}
                                disabled={submitting}
                            />
                            <Form.Control className="mb-3" as="textarea" rows={2}
                                placeholder="Enter spanish email text"
                                value={sp_emailtextpart}
                                onChange={(e) => {
                                    setSpEmailText(e.target.value)
                                    setError("")
                                }}
                                disabled={submitting}
                            />
                            <Form.Control className="mb-3" as="textarea" rows={2}
                                placeholder="Enter spanish email html"
                                value={sp_emailhtmlpart}
                                onChange={(e) => {
                                    setSpHTML(e.target.value)
                                    setError("")
                                }}
                                disabled={submitting}
                            />
                            <Form.Control className="mb-3" as="textarea" rows={2}
                                placeholder="Enter spanish sms text"
                                value={sp_smspart}
                                onChange={(e) => {
                                    setSpSMSText(e.target.value)
                                    setError("")
                                }}
                                disabled={submitting}
                            />
                            <Form.Label>
                                Preview Message Content
                            </Form.Label>
                            <Table responsive striped bordered hover style={{ textAlign: 'center', display: 'block', height: '200px', overflow: 'auto' }}>
                                <tbody>

                                    <tr >
                                        <td>English Email Subject</td>
                                        <td>{eng_emailsubject}</td>
                                    </tr>
                                    <tr >
                                        <td>English Email Content</td>
                                        <td><div>{eng_emailtextpart}</div></td>
                                    </tr>
                                    <tr >
                                        <td>English Email HTML Content</td>
                                        <td><div>{eng_emailhtmlpart}</div></td>
                                    </tr>
                                    <tr >
                                        <td>English SMS Content</td>
                                        <td>{eng_smspart}</td>
                                    </tr>

                                    <tr >
                                        <td>Spanish Email Subject</td>
                                        <td>{sp_emailsubject}</td>
                                    </tr>
                                    <tr >
                                        <td>Spanish Email Content</td>
                                        <td><div>{sp_emailtextpart}</div></td>
                                    </tr>
                                    <tr >
                                        <td>Spanish Email HTML Content</td>
                                        <td><div>{sp_emailhtmlpart}</div></td>
                                    </tr>
                                    <tr >
                                        <td>Spanish SMS Content</td>
                                        <td>{sp_smspart}</td>
                                    </tr>
                                </tbody>

                            </Table>
                        </React.Fragment>}
                    </Form.Group>
                    }

                    {error !== "" && <Alert variant={"danger"}>
                        <p>{error}</p>
                    </Alert>}

                    {submitted && <div className={"text-center"}>
                        {(incidentstatus !== 1) && <p>Alerts Sent!</p>
                        }
                        {(incidentstatus === 1) && <p>Incident Ended!</p>
                        }
                    </div>}

                    {!submitted && (incidentstatus === 1) && submitting && <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    ></Spinner>}

                    <Row style={{ marginTop: '20px' }}>
                        <Col>
                            {!submitted && !submitting && <Button variant="outline-danger" onClick={onClose}>
                                Cancel
                            </Button>}
                        </Col>

                        <Col style={{ textAlign: 'right' }}>
                            {!submitted && (incidentstatus !== 1) && <Button variant="primary" type={"submit"}>
                                {!submitting ? "Submit" : <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />}
                            </Button>}
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
        </Modal >)
}